<div class="w-100-p table-wrapper" *ngIf="dataSource">
    <span id="ruler" class="ruler"></span>

    <mat-table #table [dataSource]="dataSource" matSort>
        <!-- Avatar Column -->
        <ng-container matColumnDef="avatar">
            <mat-header-cell *matHeaderCellDef></mat-header-cell>

            <mat-cell *matCellDef="let module" class="avatar-cell cell-30 pl-20">
                <div #avatarCell *ngIf="module.image; else noModuleImage">
                    <img class="avatar pointer" [alt]="module.name" [src]="module.image.thumbUrl" />
                </div>

                <ng-template #noModuleImage>
                    <div #avatarCell>
                        <div class="avatar pointer module-icon-container no-image">
                            <mat-icon class="bg-icon" svgIcon="bg_illustration"></mat-icon>
                        </div>
                    </div>
                </ng-template>
            </mat-cell>
        </ng-container>

        <!-- Name Column -->
        <ng-container matColumnDef="name">
            <mat-header-cell class="pl-24 pr-8 name-cell" *matHeaderCellDef mat-sort-header>{{ 'GENERAL.PROPERTY.NAME' | translate }}</mat-header-cell>

            <mat-cell #nameCell *matCellDef="let module" class="pl-24 pr-8 name-cell" fxLayout="column" fxLayoutAlign="center stretch">
                <div fxLayout="row" fxLayoutAlign="start center" class="name-with-type-icon w-100-p min-w-0 relative z-[2]">
                    <mat-icon class="icon-18 mr-8 shrink-0" [svgIcon]="module | getModuleIcon"></mat-icon>
                    <span class="text-truncate font-medium min-w-0" [tooltipIfTruncated]="module.name">{{ module.name }}</span>
                </div>

                <div #tagsHost class="tags-row" fxLayout="row" fxLayoutAlign="start center" *ngIf="module.tags.length">
                    <ng-container *ngIf="module.tags | filterTags: tagsHost:this:isLoading as visibleTags">
                        <mat-chip-set class="mr-8 py-0" [class.has-more]="visibleTags.length < module.tags.length">
                            <mat-chip
                                *ngFor="let tag of visibleTags"
                                (click)="filterByTag(tag); $event.stopPropagation()"
                                class="pointer"
                                [style.background]="tag.color"
                                [disableRipple]="true"
                            >
                                {{ tag.name }}
                            </mat-chip>
                        </mat-chip-set>

                        <ng-container *ngIf="visibleTags.length < module.tags.length">
                            <div #more class="more-tags">...</div>
                            <app-tags-card [tags]="module.tags" [target]="more" (clickedTag)="filterByTag($event)"></app-tags-card>
                        </ng-container>
                    </ng-container>
                </div>
            </mat-cell>
        </ng-container>

        <!-- Version Column -->
        <ng-container matColumnDef="version">
            <mat-header-cell *matHeaderCellDef class="pl-24">
                <span class="text-sm leading-5 font-medium text-gray-600">{{ 'GENERAL.PROPERTY.VERSION' | translate }}</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let module" class="pl-24">
                <p
                    #versionEl
                    class="text-truncate"
                    [matTooltip]="module.version ? module.version : module.startDate ? (module.startDate | date: 'shortDate') + ' - ' + (module.endDate | date: 'shortDate') : '-'"
                    [matTooltipShowDelay]="500"
                    [matTooltipDisabled]="versionEl.scrollWidth <= versionEl.clientWidth"
                >
                    {{ module.version ? module.version : module.startDate ? (module.startDate | date: 'shortDate') + ' - ' + (module.endDate | date: 'shortDate') : '-' }}
                </p>
            </mat-cell>
        </ng-container>

        <!-- Module Type Column -->
        <ng-container matColumnDef="type">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.TYPE' | translate }}</mat-header-cell>

            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate" translate>{{ module.type === 'e_learning' ? 'MODULE.TYPE.E-LEARNING' : 'MODULE.TYPE.BASIC' }}</p>
            </mat-cell>
        </ng-container>

        <!-- Kind Type Column -->
        <ng-container matColumnDef="kind">
            <mat-header-cell *matHeaderCellDef fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.KIND' | translate }}</mat-header-cell>

            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate" translate>{{ module.kind | getStatusByValue: moduleKinds:'translationLabel' }}</p>
            </mat-cell>
        </ng-container>

        <!-- Module Start Date Column -->
        <ng-container matColumnDef="startDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.START_DATE' | translate }}</mat-header-cell>

            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">{{ module.startDate | date: 'shortDate' }}</p>
            </mat-cell>
        </ng-container>

        <!-- Module End Date Column -->
        <ng-container matColumnDef="endDate">
            <mat-header-cell *matHeaderCellDef mat-sort-header fxHide fxShow.gt-sm>{{ 'GENERAL.PROPERTY.END_DATE' | translate }}</mat-header-cell>

            <mat-cell *matCellDef="let module" fxHide fxShow.gt-sm>
                <p class="text-truncate">{{ module.endDate | date: 'shortDate' }}</p>
            </mat-cell>
        </ng-container>

        <!-- Buttons Column -->
        <ng-container matColumnDef="buttons">
            <mat-header-cell *matHeaderCellDef class="buttons-cell"></mat-header-cell>

            <mat-cell *matCellDef="let module" class="buttons-cell">
                <div fxFlex="row" fxLayoutAlign="end center">
                    <span
                        *ngIf="!module.selected"
                        [matTooltip]="'GENERAL.TOOLTIP.LISTED_EXECUTION_BOOKING_DISABLED' | translate"
                        [matTooltipDisabled]="isModuleSelectable(module)"
                    >
                        <app-flat-button
                            [label]="'GENERAL.BUTTON.ADD'"
                            (onClick)="addToList(module)"
                            [disabled]="!isModuleSelectable(module)"
                        ></app-flat-button>
                    </span>

                    <app-white-button
                        *ngIf="module.selected"
                        [label]="'GENERAL.BUTTON.UNSELECT'"
                        (onClick)="removeFromList(module)"
                    ></app-white-button>
                </div>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>

        <mat-row *matRowDef="let module; columns: displayedColumns" matRipple> </mat-row>
    </mat-table>

    <mat-paginator persistPageSize="all-modules.dialog-list" [length]="totalCount$ | async" [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 50]"> </mat-paginator>
</div>
